"use client"

import { useServices } from "@/hooks/use-services"
import ServicesGrid from "@/components/services-grid"
import ServicesGridSkeleton from "@/components/services-grid-skeleton"
import { AlertCircle, RefreshCcw } from "lucide-react"
import { useTranslation } from "react-i18next"

export default function ServicesGridContainer({ branchId, branchName, branchSubtitle }: { branchId: string; branchName?: string; branchSubtitle?: string }) {
  const { data: services = [], isLoading, error, refetch } = useServices(branchId)
  const { t } = useTranslation()

  if (isLoading) {
    return <ServicesGridSkeleton />
  }

  if (error || !services.length) {
    return (
      <div 
        className="flex flex-col items-center justify-center py-16 px-4 text-center animate-fade-in-up"
      >
        <div className="w-20 h-20 rounded-full bg-gray-50 flex items-center justify-center mb-4 shadow-inner">
          <AlertCircle className="w-10 h-10 text-gray-300" />
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-2">
          {error ? t("Failed to load services") : t("No services available")}
        </h3>
        <p className="text-gray-500 text-sm max-w-xs mx-auto mb-6">
          {error 
            ? t("Something went wrong while fetching services. Please try again.") 
            : t("This branch doesn't have any services listed at the moment.")}
        </p>
        {error && (
          <button 
            onClick={() => refetch()}
            className="flex items-center gap-2 px-6 py-2.5 bg-pink-600 text-white rounded-full text-sm font-bold hover:bg-gray-800 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 active:scale-95"
          >
            <RefreshCcw size={16} />
            {t("Try Again")}
          </button>
        )}
      </div>
    )
  }

  return <ServicesGrid services={services} branchId={branchId} branchName={branchName || ''} branchSubtitle={branchSubtitle || ''} />
}

